import { datadogRum } from '@datadog/browser-rum'
import { addReactError } from '@datadog/browser-rum-react'
import { ErrorInfo } from 'react'
import uncaught from 'uncaught'

import { handleChunkLoadError } from './chunkErrorReload'

const caughtErrors = new Set<Error>([])
let errorReceiver: (error: Error) => void | undefined

/**
 * Triggers the ErrorBoundary error manually, the component needs to setup the receiver to the instance
 */
export const setupErrorReceiver = (receiver: (error: Error) => void) => (errorReceiver = receiver)

export const catchError = (err: Error, info?: ErrorInfo) => {
  // Prevent the same error being reported twice
  if (caughtErrors.has(err)) return
  caughtErrors.add(err)

  // Report before handling the reload: a chunk failure means a deploy shipped
  // assets the running index.html cannot load, and this is the only signal of
  // that. Log as a React error if we have an ErrorInfo.
  if (info) addReactError(err, info)
  else datadogRum.addError(err)

  // Auto-reload only on the ErrorBoundary path, where the screen actually died.
  // The same function is the sink for the global uncaught listener, and a
  // transient network blip on a lazy or prefetched import must not reload the
  // page behind the user's back — that would discard unsent form data, which is
  // exactly what UpdatePrompt refuses to do.
  if (info && handleChunkLoadError(err)) return

  // Trigger ErrorBoundary to display the error

  // TODO: Remove comment when there are no harmless unhandled errors
  // if (errorReceiver) errorReceiver(err)
}

uncaught.start()
uncaught.addListener(err => catchError(err))
